import { connectSiteState, isLoginStateSelector } from "recoil/userInfoAtom";
import { t } from "i18next";
import { useParams } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { msgRedirectURL } from "utils/CommonFunc";
import { loginKey } from "utils/CommonTranslationKey";
import { NAVER_SIGN_IN_URL, SIGN_IN_URL } from "utils/config/Config";

export const useLoginCheck = () => {
  const isLoginState = useRecoilValue(isLoginStateSelector);
  const connectSite = useRecoilValue(connectSiteState);
  const { service_code } = useParams();

  const isNotLogin = () => {
    if (isLoginState.isLauncher) {
      window.app.vfunRequestLogin();
    } else {
      msgRedirectURL(
        t(loginKey),
        connectSite === "vfun"
          ? SIGN_IN_URL(service_code || "vfun")
          : NAVER_SIGN_IN_URL + service_code,
        "_self"
      );
    }
  };

  return isNotLogin;
};
